class BBProductGallery extends HTMLElement {
  galleryLayout = this.dataset.galleryLayout || 'one_column';
  videoControls = this.dataset.videoControls || true;
  enableImageZoom = this.dataset.enableImageZoom || true;

  connectedCallback() {
    const zoomContainer = this.querySelector('[id^="zoom-container-"]');
    const mainImage = this.querySelector('[id^="main-image-active-"]');
    this.thumbnailContainer = this.querySelector('.thumbnail-container');
    const thumbnails = this.querySelectorAll('.thumbnail-container .single-slide');
    const slickList = this.querySelector('.single-product-cover');
    if (!zoomContainer || !mainImage || !thumbnails.length || !slickList) return;

    this.thumbnails = thumbnails;

    // Theme settings
    const zoomEffect = (window.themeSettings && window.themeSettings.zoomEffect) || 'mouseover';
    const zoomMagnify = (window.themeSettings && window.themeSettings.zoomMagnify) || 1;

    // Helper to (re)initialize zoom
    const initZoom = () => {
      if (window.jQuery && window.jQuery.fn.zoom && this.enableImageZoom === 'true') {
        window.jQuery(zoomContainer).trigger('zoom.destroy');
        window.jQuery(zoomContainer).zoom({
          url: mainImage.src,
          on: zoomEffect,
          magnify: zoomMagnify
        });
      }
    };

    const reinitZoom = () => {
      if (window.jQuery && window.jQuery.fn.zoom && this.enableImageZoom === 'true') {
        const _mainImage = this.querySelector('[id^="main-image-active-"]');
        window.jQuery(zoomContainer).trigger('zoom.destroy');
        window.jQuery(zoomContainer).zoom({
          url: _mainImage.src,
          on: zoomEffect,
          magnify: zoomMagnify
        });
      }
    };

    const destroyZoom = () => {
      if (window.jQuery && window.jQuery.fn.zoom && this.enableImageZoom === 'true') {
        window.jQuery(zoomContainer).trigger('zoom.destroy');
        zoomContainer.removeAttribute('style'); // Reset styles
      }
    };

    // Helper to set slick-list height to current media
    const setSlickListHeight = () => {
      // Find the currently visible main media (img or video)
      const activeSlide = slickList.querySelector('.slick-slide.slick-current.slick-active .single-slide') || slickList.querySelector('.single-slide');
      if (!activeSlide) return;
      let mediaEl = activeSlide.querySelector('img, video');
      if (!mediaEl) return;
      // If video, wait for metadata
      const calcHeight = `calc(${mediaEl.offsetHeight}px + 10px)`;
      if (mediaEl.tagName === 'VIDEO') {
        if (mediaEl.readyState >= 1) {
          slickList.style.height = calcHeight;
        } else {
          mediaEl.addEventListener('loadedmetadata', function handler() {
            slickList.style.height = calcHeight;
            mediaEl.removeEventListener('loadedmetadata', handler);
          });
        }
      } else {
        slickList.style.height = calcHeight;
      }
    };

    if (this.galleryLayout === 'one_column') {
      // Initial zoom
      initZoom();
    }
    setTimeout(setSlickListHeight, 100); // Initial height after render

    const thumbnailBtns = this.querySelectorAll(['.slick-next', '.slick-prev']); // handle this element click

    // console.log('thumbnailBtns', thumbnailBtns, thumbnails);
    const mergedthumbnails = [...thumbnailBtns, ...thumbnails];

    // Re-init zoom and height whenever slick changes slides. Use jQuery event hooks if slick is initialized elsewhere.
    try {
      if (window.jQuery && typeof window.jQuery(slickList).on === 'function') {
        window.jQuery(slickList).on('init reInit afterChange', (event, slick, current) => {
          // If active slide is a video, destroy zoom; otherwise init zoom for that slide
          const idx = typeof current === 'number' ? current : window.jQuery(slickList).find('.slick-slide.slick-current').data('slick-index') || 0;
          const activeSlide = slickList.querySelector(`.slick-slide[data-slick-index="${idx}"] .single-slide`) || slickList.querySelector('.slick-slide.slick-current.slick-active .single-slide') || slickList.querySelector('.single-slide');
          if (!activeSlide) return;
          const isVideo = !!activeSlide.querySelector('video');
          
          // Get image from the active slide itself, not from thumbnail container
          const activeImg = activeSlide.querySelector('img');
          if (!activeImg && !isVideo) return;

          function toLargeimg(src) {
            return src
              .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|master)(?=\.)/, '')
              .replace(/\.(jpg|jpeg|png|webp)/, '_800x.$1');
          }

          const _mainImage = this.querySelector('[id^="main-image-active-"]');

          if (!isVideo && activeImg) {

            // usage
            let mainSrc = activeImg.dataset.largeUrl;
            _mainImage.src = mainSrc;
            _mainImage.alt = activeImg.alt;
          }
          
          if (isVideo) {
            destroyZoom();
          } else {
            reinitZoom();
          }
          setSlickListHeight();
        });
      }
    } catch (e) {
      console.error('Error binding slick events for zoom handling:', e);
    }
  }
}
customElements.define('bb-product-gallery', BBProductGallery); 